/**
 * Kiểm duyệt (Moderation) route family — Plans 7.2 decomposition.
 * All routes are direct children of _authenticated (authenticatedRoute).
 */
import { lazy } from "react";
import { createRoute } from "@tanstack/react-router";

import { authenticatedRoute } from "../__root.js";
import { withSuspense } from "../route-helpers.js";

// ── Lazy page imports ────────────────────────────────────────────────

const ModerationReportsPage = lazy(() =>
  import("@/features/moderation-reports").then((mod) => ({ default: mod.ModerationReportsPage })),
);
const ModerationCommentsPage = lazy(() =>
  import("@/features/workspaces/module-pages").then((mod) => ({ default: mod.ModerationCommentsPage })),
);
const ReportDetailPage = lazy(() =>
  import("@/features/moderation-reports/report-detail-page").then((mod) => ({ default: mod.ReportDetailPage })),
);
const CommentDetailPage = lazy(() =>
  import("@/features/moderation-comments/comment-detail-page").then((mod) => ({ default: mod.CommentDetailPage })),
);

// ── Routes ───────────────────────────────────────────────────────────

const moderationReportsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/kiem-duyet/bao-cao",
  component: withSuspense(ModerationReportsPage),
});
const moderationReportDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/kiem-duyet/bao-cao/$publicId",
  component: withSuspense(ReportDetailPage),
});

const moderationCommentsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/kiem-duyet/binh-luan",
  component: withSuspense(ModerationCommentsPage),
});
const moderationCommentDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/kiem-duyet/binh-luan/$publicId",
  component: withSuspense(CommentDetailPage),
});

export const kiemDuyetRoutes = [
  moderationReportsRoute,
  moderationReportDetailRoute,
  moderationCommentsRoute,
  moderationCommentDetailRoute,
];
